import { testidPart } from "@/components/site/ProductCard";

const matches = (variant, selection, skip) => Object.entries(selection).every(([name, value]) => name === skip || !value || variant.options[name] === value);

export const findVariant = (product, selection) =>
  product.variants.find((v) => product.options.every((o) => v.options[o.name] === selection[o.name])) || null;

export const initialSelection = (product) =>
  Object.fromEntries(product.options.map((o) => [o.name, o.values.length === 1 ? o.values[0] : null]));

export const VariantPicker = ({ product, selection, onChange }) => (
  <div className="space-y-6" data-testid="variant-picker">
    {product.options.map((option) => (
      <div key={option.name}>
        <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-smoke">
          {option.name}: <span className="text-bone" data-testid={`variant-selected-${testidPart(option.name)}`}>{selection[option.name] || "scegli"}</span>
        </p>
        <div className="mt-3 flex flex-wrap gap-2">
          {option.values.map((value) => {
            const available = product.variants.some((v) => v.options[option.name] === value && matches(v, selection, option.name));
            const active = selection[option.name] === value;
            return (
              <button
                key={value}
                type="button"
                disabled={!available}
                aria-pressed={active}
                onClick={() => onChange({ ...selection, [option.name]: active && option.values.length > 1 ? null : value })}
                data-testid={`variant-option-${testidPart(option.name)}-${testidPart(value)}`}
                className={`h-11 min-w-11 border px-4 font-mono text-xs uppercase tracking-[0.1em] transition-colors duration-300 disabled:cursor-not-allowed disabled:opacity-30 disabled:line-through ${active ? "border-cream bg-cream text-ink" : "border-cream/25 text-cream hover:border-cream"}`}
              >
                {value}
              </button>
            );
          })}
        </div>
      </div>
    ))}
  </div>
);
